import React, { useState } from 'react';
import Button from 'react-gazelle/lib/components/Button';
import Heading, { TAGS } from 'react-gazelle/lib/components/Heading';
import Radio from '../radio';

const MultistepForm = ({
  title,
  submitText,
  questions,
  destinations,
  surveyData,
  handleChange
}) => {
  const [stepIndex, setStepIndex] = useState(0);

  const currentQuestion = questions[stepIndex];
  const currentAnswer = surveyData[currentQuestion.name];
  const onFirstStep = stepIndex === 0;
  const onLastStep = stepIndex === questions.length - 1;
  const percentComplete = ((stepIndex + 1) * 100) / questions.length;

  const nextStep = () => {
    if (onLastStep) {
      return;
    }

    setStepIndex(stepIndex + 1);
  };

  const previousStep = () => {
    if (onFirstStep) {
      return;
    }

    setStepIndex(stepIndex - 1);
  };

  return (
    <div>
      {title ? (
        <Heading tag={TAGS.H2} secondary>
          {title}
        </Heading>
      ) : null}

      <div className="UserRoutingSurvey-steps">
        Question {stepIndex + 1} of {questions.length}
      </div>

      <div className="UserRoutingSurvey-progress">
        <div
          className="UserRoutingSurvey-progressFill"
          style={{ width: `${percentComplete}%` }}
        ></div>
      </div>

      <div className="UserRoutingSurvey-question">{currentQuestion.text}</div>

      <div className="UserRoutingSurvey-answers">
        {destinations.map((destination) => (
          <Radio
            key={destination.name}
            id={`${currentQuestion.name}-option-${destination.name}`}
            className="UserRoutingSurvey-answer"
            label={destination.label}
            name={currentQuestion.name}
            value={destination.name}
            checked={currentAnswer === destination.name}
            onChange={handleChange}
          />
        ))}
      </div>

      <div className="UserRoutingSurvey-actions">
        {onFirstStep ? (
          <div>{/* intentionally empty; used for layout purposes */}</div>
        ) : (
          <Button
            id={`nextStep-${currentQuestion.name}`}
            type="button"
            onClick={previousStep}
          >
            Previous
          </Button>
        )}

        {onLastStep ? (
          <Button
            id="user-routing-survey-submit"
            type="submit"
            disabled={!currentAnswer}
          >
            {submitText}
          </Button>
        ) : (
          <Button
            id={`nextStep-${currentQuestion.name}`}
            type="button"
            onClick={nextStep}
            disabled={!currentAnswer}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  );
};

export default MultistepForm;
